"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildFundraiserThankYouMockData = exports.FROALA_FUNDRAISER_NOTE_BODY = void 0;
const email_body_html_1 = require("../../helpers/email-body-html");
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const resolve_fundraiser_form_title_1 = require("../helpers/resolve-fundraiser-form-title");
const icons_1 = require("../icons");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const FROALA_PARAGRAPH_STYLE = "width:100%;margin:0px;box-sizing:inherit;color:rgb(0, 0, 0);line-height:1.5;";
exports.FROALA_FUNDRAISER_NOTE_BODY = `<p style="${FROALA_PARAGRAPH_STYLE}">Thank you for supporting our mission! Every dollar you raise goes directly toward the families we serve.</p>
<p style="${FROALA_PARAGRAPH_STYLE}">Reach out any time — we're here to help you succeed.</p>`;
const MOCK_FORM_LINK = "https://www.zeffy.com/en-US/fundraising/my-campaign";
const MOCK_CONNECTION_LINK = "https://zeffy.com/my-account";
const buildFundraiserThankYouMockData = ({ orgName, color, isDarkMode, body, firstName = "John", lastName = "Smith", formTitle = "My Fundraising Campaign", isIndividualFundraiser = true, formLink = MOCK_FORM_LINK, simplykConnectionLink = MOCK_CONNECTION_LINK, isFundraiserFormEditDisabled = false, locale = "en", }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    const resolvedFormTitle = (0, resolve_fundraiser_form_title_1.resolveFundraiserFormTitle)({
        title: isIndividualFundraiser ? `${firstName} ${lastName}`.trim() : formTitle,
        isIndividualFundraiser,
        locale,
    });
    return {
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme,
        iconZeffyLogo,
        lang: locale,
        subject: (0, email_templates_1.getEmailLabels)(locale)
            .fundraiserThankYouSubject.replace("{firstName}", firstName)
            .replace("{lastName}", lastName),
        orgName: orgName || "Bright Futures Foundation",
        firstName,
        lastName,
        formTitle: resolvedFormTitle,
        formLink,
        simplykConnectionLink,
        isFundraiserFormEditDisabled,
        message: body ? (0, email_body_html_1.applyCtaButtonTheme)(body, { ctaBg: theme.ctaBg, ctaText: theme.ctaText }) : "",
    };
};
exports.buildFundraiserThankYouMockData = buildFundraiserThankYouMockData;
